<template>
	<div class="cps-store-phone-screen">

		<vueWaterfallEasy 
			:imgsArr="listData"
			:allLoaded="true"
			:gap="15"
			ref="waterfall">
			<div slot="header">
				<div class="head-info">
					<div class="back" 
						v-if="$store.getters.getStoreInfo.backgroundImg"
						:style="{'background-image':'url('+ $store.getters.getStoreInfo.backgroundImg +')'}"></div>
					<div class="back" v-else></div>

					<div class="avatar">
						<div class="avatar-box">
							<img :src="$store.getters.getStoreInfo.headImg" alt="" v-if="$store.getters.getStoreInfo.headImg">
							<img src="../../assets/imgs/store/img_store_avatar.svg" alt="" v-else>
						</div>
					</div>
					<div class="inner">
						<h3 class="title">{{$store.getters.getStoreInfo.name}}</h3>
						<p class="desc">{{$store.getters.getStoreInfo.intro}}</p>
					</div>
				</div>
				<div class="arc-box" :class="[$store.getters.getClassifyList.length ? 'white':'']"></div>
				<div class="inner-wrapper" v-if="$store.getters.getClassifyList.length">
					<dl class="classify-box white">
						<dd class="item" v-for="(item,index) in $store.getters.getClassifyList" :key="index" @click="handleToClassify(item.id)">
							<div class="logo">
								<img :src="item.typeImg" alt="" v-if="item.typeImg">
								<template v-else>
									<img src="../../assets/imgs/store/img_classify_0.svg" alt="" v-if="index === 0">
									<img src="../../assets/imgs/store/img_classify_1.svg" alt="" v-if="index === 1">
									<img src="../../assets/imgs/store/img_classify_2.svg" alt="" v-if="index === 2">
									<img src="../../assets/imgs/store/img_classify_3.svg" alt="" v-if="index === 3">
								</template>
							</div>
							<p class="tit">{{item.typeName}}</p>
						</dd>
					</dl>
				</div>
				<h3 class="block">
					精选推荐 
					<a href="javascript:;" class="link" @click="handleToClassify('')" v-if="$store.getters.getClassifyList.length">全部 <md-icon name="arrow-right"></md-icon></a></h3>
			</div>
			<div slot="footer" class="more">
				<a href="javascript:;" class="link" @click="handleToClassify('')">查看更多</a>
			</div>
		</vueWaterfallEasy>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	import StoreList from './components/StoreList'
	import Empty from './components/StoreEmpty.vue'
	import vueWaterfallEasy from './components/Waterfall'

	export default {
		data() {
			return {
				listData: []
			}
		},
		components: {
			StoreList,
			Empty,
			vueWaterfallEasy
		},
		methods: {
			//去分类列表
			handleToClassify(typeId='') {

				let _typeId = typeId ? typeId : this.$store.getters.getClassifyList[0].id;

				this.$router.push({
					name: 'storeClassify',
					params: {
						shopId: this.$route.params.shopId
					},
					query: {
						typeId: _typeId
					}
				})
			}
		},
		mounted() {
			this.listData = this.$store.getters.getChoicenessList
		},
		watch: {
			'$store.getters.getChoicenessList': function(){
				this.listData = this.$store.getters.getChoicenessList
			}
		}
	}
</script>

<style lang="scss" scoped="">
	.cps-store-phone-screen{
		position: relative;
		width: 100%;
		height: 100vh;

		.head-info{
			display: flex;
			align-items: center;
			height: 236px;
			padding: 48px 48px 68px;
			box-sizing: border-box;
			color: #fff;
			position: relative;
			background-color: #e8e8e8;
			
			.back{
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				z-index: 1;
				background-image: url('../../assets/imgs/store/img_store_back.png');
				background-repeat: no-repeat;
				background-position: center;
				background-size: cover;
			}
			.avatar{
				width: 140px;
				height: 140px;
				border-radius: 50%;
				overflow: hidden;
				background: rgba(255,255,255, .5);
				padding: 8px;
				box-sizing: border-box;
				flex-shrink: 0;
				position: relative;
				z-index: 2;
				margin-right: 24px;
				
				.avatar-box{
					width: 100%;
					height: 100%;
					background-color: #e8e8e8;
					border-radius: 50%;
				}
				img{
					width: 100%;
					height: 100%;
					display: block;
					border-radius: 50%;
				}
			}
			.inner{
				position: relative;
				z-index: 2;
				flex: 1;
			}
			.title{
				font-size: 32px;
				font-weight: bold;
				margin: 0;
			}
			.desc{
				font-size: 24px;
				margin-top: 8px;
				word-break: break-all;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				/* autoprefixer: ignore next */
				-webkit-box-orient: vertical;
			}
		}
		.arc-box{
			position: relative;
			height: 0;

			&:after{
				content: '';
				width: 140%;
				height: 160px;
				position: absolute;
				left: -20%;
				top: -30px;
				z-index: 1;
				border-radius: 50% 50% 0 0;
				background-color: #F8F9FC;
			}
			&.white{

				&:after{
					background-color: #fff;
				}
			}
		}
		.inner-wrapper{
			position: relative;
			z-index: 10;
		}
		.classify-box{
			display: flex;
			padding-top: 10px;
			padding-bottom: 40px;
			margin: 0;
			background-color: #F8F9FC;
			
			&.white{
				background-color: #fff;
			}
			.item{
				margin: 0;
				flex-shrink: 0;
				flex: 1;
				display: flex;
				align-items: center;
				flex-direction: column;
			}
			.logo{
				width: 80px;
				height: 80px;
				border-radius: 50%;
				overflow: hidden;
				background-color: #e8e8e8;

				img{
					width: 100%;
					height: 100%;
					display: block;
				}
			}
			.tit{
				color: #666666;
				margin: 0;
				margin-top: 16px;
				font-size: 28px;
			}
		}
		.block{
			font-size: 36px;
			color: #222;
			font-weight: bold;
			padding: 30px 30px 7.5px;
			box-sizing: border-box;
			position: relative;
			z-index: 99;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.link{
				color: #999999;
				font-size: 24px;
				text-decoration: none;
				font-weight: 400;
			}
			.md-icon{
				font-size: 24px;
			}
		}
		.more{
			text-align: center;

			.link{
				display: inline-block;
				color: #3399FF;
				font-size: 24px;
				font-weight: 400;
				text-decoration: none;
			}
		}
		.choiceness-list{

			&:after{
				content: '';
				clear: both;
				display: table;
			}
			li{
				width: 48%;
				float: left;
				margin-right: 4%;

				&:nth-child(2n){
					margin-right: 0;
				}
			}
		}
		.choiceness{
			padding: 0 30px;
			box-sizing: border-box;
			position: relative;
			z-index: 99;
		}
		.choiceness-item{
			display: flex;
			height: 170px;
			align-items: center;
			justify-content: center;
			font-size: 28px;
			color: #CCCCCC;
			border: 1px solid #E8E8E8;
			border-radius: 20px;
			margin-bottom: 30px;
			background-color: #fff;
		}
		.cps-store-list{
			padding-bottom: 40px;
		}
	}
</style>